// Stacking for the global dialogs that portal to document.body: the post-login passkey prompt and
// the two-factor challenge mounted beside it in App.js.
//
// It has to clear TWO bands, and only the first was understood when this value was first set:
//
//   1. The layout chrome. antd's default 1000 leaves the dialog UNDER layout 3's header (1002) and
//      sider (1001). The chrome then sits on top and swallows every click meant for Later and the
//      close button -- which is how it became impossible to dismiss, with its mask leaving the whole
//      portal unnavigable (QA, production, 2026-08-29).
//
//   2. The layout MODAL band. `#layout-3 .ant-modal-mask { z-index: 1199 }` and
//      `#layout-3 .ant-modal-wrap { z-index: 1200 }` raise every in-layout modal above that same
//      chrome. These dialogs portal to body, so those rules never match them -- and at 1100 they
//      lost to any modal that was already open. A two-factor challenge raised FROM a modal (the
//      prediction funding and change-password dialogs both do) then rendered behind it, invisible
//      and unclickable, and the action hung forever waiting on a verdict nobody could give
//      (2026-09-11, prediction change password on layout 3).
//
// 1300 clears both. Layout 3's ceiling is 1200 (the modal wrap and the image preview wrap); no
// layout goes higher.
//
// Kept in its own module deliberately: the dialog imports apollo and axios, so anything that has to
// read this value in a test cannot afford to import the component to get it.
export const PASSKEY_PROMPT_Z_INDEX = 1300;

export default PASSKEY_PROMPT_Z_INDEX;
